import type { ReactNode } from 'react'
import { cn } from '../../lib/utils'

interface InstrumentPanelProps {
  /** 面板标题带：小字号宽字距，工程图注记风格 */
  title: string
  /** 标题带右侧等宽注记（编号/单位/量纲） */
  meta?: ReactNode
  children: ReactNode
  className?: string
  bodyClassName?: string
}

/**
 * 仪器舱面板：细边框 + 标题带 + 等宽注记，替代通用玻璃卡。
 * 用于指挥屏的功能区，管理后台页面继续用 panel-glass。
 */
export function InstrumentPanel({ title, meta, children, className, bodyClassName }: InstrumentPanelProps) {
  return (
    <section aria-label={title} className={cn('rounded-md border border-border bg-card', className)}>
      <header className="flex items-center justify-between gap-2 border-b border-border px-3 py-2">
        <h2 className="text-[10px] font-medium tracking-[0.2em] text-muted-foreground">{title}</h2>
        {meta != null && <span className="truncate font-mono text-[10px] text-muted-foreground">{meta}</span>}
      </header>
      <div className={cn('p-3', bodyClassName)}>{children}</div>
    </section>
  )
}
